import { List } from "immutable";
import { Media } from "@domain/media/media";

export const getAssetById = (content: { assets: List<Media> }, id: string): Media | undefined => {
	return content.assets?.find((asset) => asset.id === id);
};
